import { defineStore } from 'pinia';
import * as azdev from 'azure-devops-node-api';

import {
  ADO_URL,
  NVENTIVE_ORG,
  API_VERSION,
  AzureDevOpsScopes,
} from '@/settings';
import {
  decryptToken,
} from '@/helpers/encryptDecrypt';
import useAuthStore from '@/stores/checkAuth';

const useApiStore = defineStore('api', {
  state: () => ({
    bearerToken: null, ORG_URL: '', coreApi: null, workApi: null, itemsApi: null, wikiApi: null, gitApi: null,
  }),
  getters: {
    getBearerToken: (state) => state.bearerToken,
  },
  actions: {
    async checkOrgnizationAndTokenValidity(token, orgName) {
      try {
        const response = await fetch(`https://dev.azure.com/${orgName}/_apis/projects?api-version=${API_VERSION}`, {
          headers: {
            Authorization: `Basic ${btoa(`:${token}`)}`,
            'Content-Type': 'application/json',
          },
        });
        if (response.status === 200) {
          console.log('Organization exists and token is valid.');
          return true;
        }
        console.error(`Organization ${orgName} or token is not valid.`);
        return false;
      } catch (error) {
        console.error('Error in validation: ', error);
        return false;
      }
    },
    async setOrganization(organization) {
      if (!organization) {
        console.error('Organization is not defined.');
        return;
      }
      if (organization.value === NVENTIVE_ORG) {
        await this.handleNventiveOrg();
        return;
      }
      const secretKey = process.env.VUE_APP_ENCRYPTION_DECRYPTION_KEY;
      const decryptedPAT = decryptToken(organization.key, secretKey);
      const authHandler = azdev.getPersonalAccessTokenHandler(decryptedPAT);
      await this.updateConnection(authHandler, organization.value);
    },
    async handleNventiveOrg() {
      const authStore = useAuthStore();
      if (!this.bearerToken) {
        this.bearerToken = await authStore.getAccessToken(AzureDevOpsScopes);
        if (!this.bearerToken) {
          console.error('Failed to acquire bearer token.');
          return;
        }
      }
      const authHandler = azdev.getBearerHandler(this.bearerToken);
      await this.updateConnection(authHandler, NVENTIVE_ORG);
    },
    async updateConnection(authHandler, orgName) {
      this.ORG_URL = ADO_URL + orgName;
      const connection = new azdev.WebApi(this.ORG_URL, authHandler);

      await connection.getCoreApi().then((c) => {
        this.coreApi = c;
      });
      await connection.getWorkApi().then((w) => {
        this.workApi = w;
      });
      await connection.getWorkItemTrackingApi().then((wi) => {
        this.itemsApi = wi;
      });
      await connection.getGitApi().then((g) => {
        this.gitApi = g;
      });
    },
  },
});

export default useApiStore;
